import {type CSSProperties} from "aphrodite";
import {useMemo} from "react";

import {type StyleType} from "@khanacademy/wonder-blocks-core";
import {font} from "@khanacademy/wonder-blocks-tokens";
import {usePrefersReducedMotion} from "@khan/data-prefers-reduced-motion";

import {ShimmerRectangle} from "./shimmer.tsx";

type Props = {
    width?: CSSProperties["inlineSize"];
    style?: StyleType;
} & (
    | {
          kind: "body";
          size: keyof typeof font.body.size;
      }
    | {
          kind: "heading";
          size: keyof typeof font.heading.size;
      }
);

/**
 * ShimmerText is a component that renders a shimmering rectangle to mimic
 * a single line of text.
 */
export const ShimmerText = ({
    kind = "body",
    size = "medium",
    width = "100%",
    style,
}: Props) => {
    const animated = !usePrefersReducedMotion();
    const dimensionStyles = useMemo(
        () => ({
            width,
            height: font[kind].lineHeight[size],
            inlineSize: width,
            blockSize: font[kind].lineHeight[size],
        }),
        [kind, size, width],
    );
    return (
        <ShimmerRectangle
            animated={animated}
            style={[dimensionStyles, style]}
            // Unset these so they can be overridden by dimensionStyles.
            height="unset"
            width="unset"
        />
    );
};
